// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z3Ctv","col":"styles_col__11yeN","actions":"styles_actions__3CUmi","conflict":"styles_conflict__10pCl"};